import { defineComponent as o, openBlock as r, createBlock as a, unref as l, mergeProps as p, withCtx as c, createElementVNode as m } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconPercentage",
  __name: "IconPercentage",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (d, e) => (r(), a(l(i), p(n, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M20.53 3.47a.75.75 0 0 1 0 1.06l-16 16a.75.75 0 0 1-1.06-1.06l16-16a.75.75 0 0 1 1.06 0M6.5 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m11 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6.5 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m11 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
